import React from "react";
import styles from "./Divider.module.scss";

interface DividerProps {
  className?: string;
}

const Divider = ({ className = "" }: DividerProps) => {
  return (
    <hr
      className={`${styles.divider} ${className}`}
      style={{
        backgroundImage: `url(${
          process.env.PUBLIC_URL + "/images/decors/solvize-divider.svg"
        })`,
      }}
    />
  );
};

export default Divider;
